import { useEffect, useState } from "react";
import { getVideoCreationJobDetail } from "@apis/http/api";
import type { JobDetailData } from "@apis/videoCreatingService";

export const useJobDetail = (jobId: string | number | undefined, refreshKey?: string) => {
  const [detail, setDetail] = useState<JobDetailData | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!jobId) {
      setDetail(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setDetail(null);
    getVideoCreationJobDetail({ jobId: Number(jobId) })
      .then((res) => {
        if (!cancelled) setDetail(res as any);
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [jobId, refreshKey]);

  return { detail, loading };
};
